export default __webpack_public_path__ + "static/regular-cabin-kitchen2-538c7fef88db7476b1b3c1259c3234ed.jpg";